import Image from "next/image";
import {gsap, Linear} from "gsap";
import {ScrollTrigger} from 'gsap/dist/ScrollTrigger';
import imageMenzies from "../public/img/logos/menzies.png";
import imageKLM from "../public/img/logos/klm.png";
import imageJobair from "../public/img/logos/jobair.png";
import imageUPS from "../public/img/logos/ups.png";
import imageHMS from "../public/img/logos/hms.png";
import imageSwissport from "../public/img/logos/swissport.png";
import imageSchiphol from "../public/img/logos/schiphol.png";
import imageAsito from "../public/img/logos/asito.png";
import imageGeodis from "../public/img/logos/geodis.png";
import imageDnata from "../public/img/logos/dnata.png";
import {useEffect, useRef} from "react";

gsap.registerPlugin(ScrollTrigger);

const logos = [
    imageMenzies,
    imageKLM,
    imageJobair,
    imageUPS,
    imageHMS,
    imageSwissport,
    imageSchiphol,
    imageAsito,
    imageGeodis,
    imageDnata
];

const rhTickerMove = (element, tickerWidth, time) => {
    gsap.set(element, {x: 0});
    gsap.to(element,
        {
            duration: time,
            x: -tickerWidth,
            ease: Linear.easeNone,
            onComplete: rhTickerMove,
            onCompleteParams: [element, tickerWidth, time],
            scrollTrigger: {
                trigger: element,
                start: "80% bottom"
            }
        },
    );
};

export default function CompanyLogos() {
    const wrapperRef = useRef()

    useEffect(() => {
        if (wrapperRef.current && window && window.innerWidth < 768) {
            const tickerInner = wrapperRef.current;
            // const tickerInner = ticker.querySelector('.js-ticker-inner');
            let tickerWidth = 0;
            // const tickerWidth = tickerInner.offsetWidth;
            const time = 0.11 * window.innerWidth;

            tickerInner.childNodes.forEach((node) => {
                tickerWidth += node.offsetWidth;
                tickerInner.appendChild(node.cloneNode(true));
            });

            rhTickerMove(tickerInner, tickerWidth, time);
        }
    }, []);

    return (
        <div
            ref={wrapperRef}
            className="w-full flex items-center gap-0 md:flex-wrap md:justify-center max-w-[1000px]"
        >
            {logos.map((logo, key) => {
                return (
                    <div key={`Logo: ${key}`} className="relative shrink-0 w-full max-w-[250px] aspect-[26/15]">
                        <Image src={logo} lazyBoundary="700px" layout="fill" objectFit="contain" alt=""/>
                    </div>
                )
            })}
        </div>
    )
}